import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "PreLoaderWrapper" }
const _hoisted_2 = {
  key: 0,
  class: "Text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "PreLoader" }, [
      _createElementVNode("div", { class: "Dot" }),
      _createElementVNode("div", { class: "Dot" }),
      _createElementVNode("div", { class: "Dot" })
    ], -1 /* HOISTED */)),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}